module.exports = __webpack_public_path__ + "assets/img/4_34_big.df8319e8.jpg";